window.MotorRenewalDetails = (function () {
    'use strict';
    window.dataLayer = window.dataLayer || [];
    var self = {
        httpStatusCode: {
            Created: "201",
            LoginTimeout: "440",
            UnAuthorized: "401",
            RequestError: "400",
            ResourceError: "404",
            GenericError: "500",
            ServiceUnavailable: "503"
        },
        constants: {
            MaxAllowedEntries: parseInt($('div.NumberOfCars').text(), 10),
            DefaultDay: parseInt($('div.DefaultDay').text(), 10),
            RegistrationNumber_regex:
                new RegExp(['/([a-zA-Z]{2}[0-9]{2}\s?[a-zA-Z]{3}$)|([a-zA-Z][0-9]{1,3}\s?[a-zA-Z]{3}$)',
                    '|([a-zA-Z]{3}\s?[0-9]{1,3}[a-zA-Z]$)|([0-9]{1,4}\s?[a-zA-Z]{1,2}$)|([0-9]{1,3}\s?[a-zA-Z]{1,3}$)',
                    '|([a-zA-Z]{1,2}\s?[0-9]{1,4}$)|(^[a-zA-Z]{1,3}\s?[0-9]{1,3}$)/,'].join('')),
            Digits_regex: /^[0-9]+$/,
            CurrentDate: new Date()
        },
        elements: {
            buttons: {
                AddAnotherItemButton: '#renewal-details-add-another-item',
                RemoveItemButton: '#renewal-details-remove-item',
                SubmitButton: '#renewal-details-submit',
                TooltipShowButton: '#show-tooltip'
            },
            sections: {
                Success: '#capture-details-success',
                CaptureRenewalDetailsForm: '#capture-details-form'
            },
            messages: {
                ServiceError: '#technical-failure'
            }
        },
        urls: {
            SubmitRenewalDetailsUrl: '/api/sitecore/RenewalDetails/SubmitCaptureDetails'
        },
        func: {
            init: function() {
                self.func.bindings();
                $(self.elements.messages.ServiceError).hide();
                $(self.elements.buttons.RemoveItemButton).first().hide();
                $(self.elements.sections.Success).hide();
                $('form').find('.vds-form__validation-message').hide();
            },
            bindings: function() {
                $(self.elements.buttons.AddAnotherItemButton).on('click', self.func.handleAddNewItemClick);
                $(self.elements.buttons.RemoveItemButton).on('click', self.func.handleRemoveItemClick);
                $(self.elements.buttons.SubmitButton).on('click', self.func.handleSubmitButtonClick);
                $(self.elements.buttons.TooltipShowButton).on('click', self.func.tooltipClick);

                $('.vds-form__date').change(self.func.validateRenewalDate);
                $('.reg').on('blur', self.func.formatRegistrationNumber);
                $('.month').on('keypress', self.func.validateMonth);
                $('.reg').change(self.func.validateRegistrationNumber);
                $('.vds-tooltip__trigger').on('click', self.func.bindTooltip);
            },
            helpers: {
                reloadPage: function() {
                    window.location.reload(true);
                }
            },
            validateMonth: function (event) {
                var charTyped = String.fromCharCode(event.which);
                var matchValue = charTyped.match(self.constants.Digits_regex);
                return matchValue === null ? false : true;            
            },
            formatRegistrationNumber: function() {
                var text = $(this).val().trim();
                $(this).val(text.replace(/\s+/g, '').toUpperCase());
            },
            getCarDetails: function () {
                var carRegistrationList = [];
                var month = [];
                var resultantProspect = [];
                let year = self.constants.CurrentDate.getFullYear();
                $('input.reg').each(function() {
                    carRegistrationList.push($(this).val());
                });
                $('input.month').each(function () {
                     month.push(('0' + $(this).val()).slice(-2));
                });

                for (var i = 0; i < month.length; i++) {
                    if (month[i] <= self.constants.CurrentDate.getMonth()) {
                        year = year + 1;
                    }
                    resultantProspect.push(
                        {
                            MotorRegistrationNumber: carRegistrationList[i],
                            MotorRenewalDate: (year + '-' + month[i] + '-' +'0' + self.constants.DefaultDay)
                        });
                }
                return resultantProspect;
            },
            handleSubmitButtonClick: function (event) {
                event.preventDefault();
                self.func.submitRenewalDetails();
            },
            validateForm: function () {
                 if ($('.month:empty').length > 0) {
                    $('.month:empty').trigger('change');
                }
                return $('.vds-form__validation-message:visible').length === 0;
            },
            handleAddNewItemClick: function(event) {
                if (self.func.validateForm()) {
                    var clone = $(event.target).closest('div').prev('.vds-capture-details__group').clone(true)
                        .find('input:text').val('').end();
                    $(event.target).closest('div').prev('.vds-capture-details__group').after(clone);
                    self.func.handleHeadingChange();
                    $('button#renewal-details-remove-item').last().show();

                    if (document.getElementsByClassName('vds-capture-details__group').length >=
                        self.constants.MaxAllowedEntries) {
                        $(self.elements.buttons.AddAnotherItemButton).addClass('vds-icon-link--disabled');
                    }
                }
            },
            handleHeadingChange: function() {
                var i = 0;
                $(".vds-capture-details__form h3:contains('Car')").each(function () {
                    i = i + 1;
                    $(this).text('Car 0' + i);
                });
            },
            bindTooltip: function () {
                $(this).parent().addClass('vds-tooltip--active');                
            },
            tooltipClick: function(event) {
                event.preventDefault();
                self.func.bindTooltip();
            },
            handleRemoveItemClick: function(event) {
                $(event.target).closest('fieldset').remove();
                self.func.handleHeadingChange();
                if (document.getElementsByClassName('vds-capture-details__group').length >=
                    self.constants.MaxAllowedEntries) {
                    $(self.elements.buttons.AddAnotherItemButton).addClass('vds-icon-link--disabled');
                } else {
                    $(self.elements.buttons.AddAnotherItemButton).removeClass('vds-icon-link--disabled');
                }
            },
            submitRenewalDetails: function () {
                $(self.elements.messages.ServiceError).hide();
                if (self.func.validateForm()) {
                    $.ajax({
                        type: 'POST',
                        url: self.urls.SubmitRenewalDetailsUrl,
                        data: { renewalDetails: self.func.getCarDetails() },
                        success: self.func.submitRenewalDetailsSuccess,
                        error: self.func.submitRenewalDetailsError
                    });
                }
                return;
            },
            submitRenewalDetailsSuccess: function (data) {
                if (data !== null && data !== undefined) {
                    if (data.errorCode === (self.httpStatusCode.UnAuthorized || self.httpStatusCode.GenericError ||
                        (self.httpStatusCode.RequestError) || (self.httpStatusCode.ResourceError) || (self.httpStatusCode.ServiceUnavailable))) {
                        self.func.helpers.reloadPage();
                    } else {
                        $(self.elements.sections.Success).show();
                        $(self.elements.sections.CaptureRenewalDetailsForm).hide();
                        window.dataLayer.push(self.gtm.submitButtonClickEventSuccessState);
                    }
                } else {
                    $(self.elements.messages.ServiceError).show();
                }
            },
            submitRenewalDetailsError: function (jqxhr) {
                if (jqxhr.status === self.httpStatusCode.LoginTimeout) {
                    self.func.helpers.reloadPage();
                } else {
                    $(self.elements.messages.ServiceError).show();
                }
            },
            validateRenewalDate: function (event) {
                var updatedDateSection = $(event.target).closest('.vds-form__date');
                var month = parseInt(updatedDateSection.find('.month').val(), 10);
                var validationMessages = updatedDateSection.contents().filter('.vds-form__validation-message');
                $(validationMessages).hide();
                self.func.validateDate(month, validationMessages);
            },
            validateRegistrationNumber: function(event) {
                $(event.target).next('.vds-form__validation-message').hide();
                if ($(this).val()) {
                    var isValid = $(this).val().trim().match(self.constants.RegistrationNumber_regex);
                    if (isValid === null) {
                        $(event.target).next('.vds-form__validation-message').show();
                    }
                }
            },
            validateDate: function (month, validationMessages) {
                if (isNaN(month)) {
                    $(validationMessages[0]).show();
                } else if (month < 1 || month > 12) {
                    $(validationMessages[1]).show();
                } else {
                    $(validationMessages).hide();
                }
            }
        },
        gtm: {
            submitButtonClickEventSuccessState: {
                event: 'renewalSubmit',
                productCategory:'car',
                state: 'success'
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$('document').ready(function () {
    if ('motorRenewalDetails' === $('#page-data').data('feature')) {
        window.MotorRenewalDetails.Init();
    }
});


